import { useFormContext, Controller } from 'react-hook-form';
import { cn } from '../../lib/utils';
import { UploadAvatar, Upload, UploadBox, UploadProps } from '../upload';

// ----------------------------------------------------------------------

interface Props extends Omit<UploadProps, 'file'> {
  name: string;
  multiple?: boolean;
}

// ----------------------------------------------------------------------

export function RHFUploadAvatar({ name, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <UploadAvatar
            accept={{
              'image/*': []
            }}
            error={!!error}
            file={field.value}
            {...other}
          />

          {!!error && (
            <p className={cn('mt-2 text-center text-sm text-destructive')}>{error.message}</p>
          )}
        </div>
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFUploadBox({ name, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <UploadBox files={field.value} error={!!error} {...other} />
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFUpload({ name, multiple, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) =>
        multiple ? (
          <Upload
            multiple
            accept={{ 'image/*': [] }}
            files={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <p
                  className={cn(
                    'mt-2 px-2 text-sm',
                    error ? 'text-destructive' : 'text-muted-foreground'
                  )}
                >
                  {error ? error.message : helperText}
                </p>
              )
            }
            {...other}
          />
        ) : (
          <Upload
            accept={{ 'image/*': [] }}
            file={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <p
                  className={cn(
                    'mt-2 px-2 text-sm',
                    error ? 'text-destructive' : 'text-muted-foreground'
                  )}
                >
                  {error ? error.message : helperText}
                </p>
              )
            }
            {...other}
          />
        )
      }
    />
  );
}
